import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { ordinalSuffixFormatter } from 'helper';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';
import StructuralMaterialsList from '../modals/StructuralMaterialsList';

function StructuralMaterialsContainer({
  applicationId,
  getRoofList,
  roofList,
  getFlooringList,
  flooringList,
  getWallsAndPartitionList,
  wallsAndPartitionList,
  type,
  isLoading,
  isLoading2,
  isLoading3,
  getFloorList,
  floorArea,
  applicationInfo
}) {
  const setModal = useContext(ModalContext);

  const formatStructuralMaterials = (data) => {
    const format = data.map(item => ({
      id: _.get(item, 'id'),
      rptax_building_material_id: _.get(item, 'attributes.rptax_building_material_id'),
      rptax_building_material_name: _.get(item, 'attributes.rptax_building_material_name'),
      rptax_building_material_type_id: _.get(item, 'attributes.rptax_building_material_type_id'),
      rptax_building_material_type_name: _.get(item, 'attributes.rptax_building_material_type_name'),
      material_name: _.get(item, 'attributes.rptax_building_material_name'),
      floor: _.get(item, 'attributes.floor'),
    }));
    return format;
  };

  const formatFloorArea = (data) => {
    const format = data.map(item => ({
      id: _.get(item, 'id'),
      floor: _.get(item, 'attributes.floor'),
      area: _.get(item, 'attributes.area'),
    }));
    return format;
  };

  const getArray = (data) => {
    let val = '';
    switch (data) {
      case 'Roof':
        val = formatStructuralMaterials(roofList);
        break;
      case 'Flooring':
        val = formatStructuralMaterials(flooringList);
        break;
      case 'Walls & Partitions':
        val = formatStructuralMaterials(wallsAndPartitionList);
        break;
      default:
        val = '';
        break;
    }
    return val;
  };

  const handleEditButtonClicked = structuralType => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <StructuralMaterialsList
          dataInfo={getArray(structuralType)}
          applicationId={applicationId}
          floorArea={formatFloorArea(floorArea)}
          type={structuralType}
        />
      ),
      title: 'Update Structural Material',
      modalSize: 'modal-xl',
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getFloorList(applicationId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getFlooringList(applicationId, { isPaginate: 1, material_type_name: 'Flooring' });
    getRoofList(applicationId, { isPaginate: 1, material_type_name: 'Roof' });
    getWallsAndPartitionList(applicationId, { isPaginate: 1, material_type_name: 'Walls & Partitions' });
  }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getFlooringList(applicationId, { isPaginate: 1, material_type_name: 'Flooring' });
    getRoofList(applicationId, { isPaginate: 1, material_type_name: 'Roof' });
    getWallsAndPartitionList(applicationId, { isPaginate: 1, material_type_name: 'Walls & Partitions' });
  }, [applicationId]);

  return (
    <div>
      <div className="p-3 row">
        <div className="col-8 header-modal">
          Roof Materials
        </div>
        {
          [
            'PENDING',
            'FOR APPRAISAL AND ASSESSMENT',
            'TRANSFERRED',
            'FOR REASSESSMENT',
          ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 && type !== 'history'
          && (
            <div className="col-4 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleEditButtonClicked('Roof')}
                  className="btn button-transaction font-weight-bold"
                >
                  <i className="fas fa-edit" /> &nbsp; Edit Roof Materials
                </button>
              </div>
            </div>
          )}
      </div>

      <div className="p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Materials</td>
                  </tr>
                </thead>
                <tbody>
                  {_.isEmpty(roofList) ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    roofList.map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.rptax_building_material_name') || ''}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
      <div className="p-3 row">
        <div className="col-8 header-modal">
          Flooring Materials
        </div>
        {
          [
            'PENDING',
            'FOR APPRAISAL AND ASSESSMENT',
            'TRANSFERRED',
            'FOR REASSESSMENT',
          ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 && type !== 'history'
          && (
            <div className="col-4 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleEditButtonClicked('Flooring')}
                  className="btn button-transaction font-weight-bold"
                  style={{ width: 190 }}
                >
                  <i className="fas fa-edit" /> &nbsp; Edit Flooring Materials
                </button>
              </div>
            </div>
          )}
      </div>
      <div className="p-0 mr-2">
        {isLoading2 ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <th width="350">Materials</th>
                    {(floorArea || []).map((s) => (
                      <th key={s.id} style={{ textAlign: 'center' }}>{ordinalSuffixFormatter(s.attributes.floor)}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(flooringList || []).length === 0 ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    flooringList.map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.rptax_building_material_name') || ''}</td>
                        {(floorArea || []).map((s) => (
                          <td style={{ textAlign: 'center' }} key={s.id}>
                            <input
                              readOnly
                              type="checkbox"
                              checked={item.attributes.floor.includes(s.attributes.floor)}
                              value={s}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
      {type !== 'history' && (
        <div className="p-3 row">
          <div className="col-8 header-modal">
            Walls & Partitions Materials
          </div>
          <div className="col-4 d-flex">
            <div className="ml-auto">
              <button
                type="button"
                onClick={handleEditButtonClicked('Walls & Partitions')}
                className="btn button-transaction font-weight-bold"
              >
                <i className="fas fa-edit" /> &nbsp; Edit Walls & Partitions
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="p-0 mr-2">
        {isLoading3 ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Building Material</td>
                    {(floorArea || []).map((s) => (
                      <th key={s.id} style={{ textAlign: 'center' }}>
                        {ordinalSuffixFormatter(s.attributes.floor)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {_.isEmpty(wallsAndPartitionList) ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    wallsAndPartitionList.map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.rptax_building_material_name') || ''}</td>
                        {(floorArea || []).map((s) => (
                          <td style={{ textAlign: 'center' }} key={s.id}>
                            <input
                              readOnly
                              type="checkbox"
                              checked={item.attributes.floor.includes(s.attributes.floor)}
                              value={s}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

StructuralMaterialsContainer.propTypes = {
  applicationId: PropTypes.string,
  getRoofList: PropTypes.instanceOf(Function).isRequired,
  roofList: PropTypes.instanceOf(Array).isRequired,
  getFloorList: PropTypes.instanceOf(Function).isRequired,
  getFlooringList: PropTypes.instanceOf(Function).isRequired,
  flooringList: PropTypes.instanceOf(Array).isRequired,
  getWallsAndPartitionList: PropTypes.instanceOf(Function).isRequired,
  wallsAndPartitionList: PropTypes.instanceOf(Array).isRequired,
  floorArea: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isLoading2: PropTypes.bool.isRequired,
  isLoading3: PropTypes.bool.isRequired,
  applicationInfo: PropTypes.instanceOf(Object),
};

StructuralMaterialsContainer.defaultProps = {
  applicationId: '',
  type: '',
  applicationInfo: {},
};

const mapStateToProps = ({ api }) => ({
  roofList: _.get(api, `${c.GET_ROOF_LIST}.list`) || [],
  flooringList: _.get(api, `${c.GET_FLOORING_LIST}.list`) || [],
  wallsAndPartitionList: _.get(api, `${c.GET_WALLS_AND_PARTITION_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_ROOF_LIST) > -1,
  isLoading2: _.get(api, 'loading', []).indexOf(c.GET_FLOORING_LIST) > -1,
  isLoading3: _.get(api, 'loading', []).indexOf(c.GET_WALLS_AND_PARTITION_LIST) > -1,
  floorArea: _.get(api, `${c.GET_FLOOR_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(StructuralMaterialsContainer);